// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalConfirm_container__2rOJH","btns":"ModalConfirm_btns__2sf7g","cancel":"ModalConfirm_cancel__3Fg2R"};